import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { PeilutService } from "./peilut.service";
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { IPeilut } from "./peilut.interface";
import { IRishum } from "./rishum";
import { IUserDetails } from "./user-details";
import { ITatPeilut } from "./tat-peilut";
import { CustomValidators } from "ng2-validation";
import { CustomDisabledDirective } from "../shared/directives/custom-disabled.directive";
import { IMyOptions } from "mydatepicker";
import { AppSettings } from "app/shared/app-settings";
import { IPeiluyot } from "app/peiluyots/peiluyot.interface";
import { IUserPeilutData } from "./userPeilutData";

// 1. create new file: peilut.interface.ts and copy properties from peilut.ts
// 2. delete peilut.ts
// 3. create new interface - peiluyot.interface.ts that contains peilut interface and an array of tat-peilut interface.
// 4. in variable peiluyot declaration, replace type to array of peiluyot.
// 5. in method param, change type from ipeilut to peiluyot

@Component({
  moduleId: module.id,
  selector: "peiluyot",
  templateUrl: "./peilut.component.html",
  providers: [PeilutService],
})
export class PeilutComponent implements OnInit {
  rishum: FormGroup;
  errorMessage: string;
  peiluyot: IPeiluyot[];
  selectedPeilut: IPeilut;
  user: IUserDetails;
  tatpeilut: ITatPeilut[];
  tatPeilutBoker: ITatPeilut[];
  tatPeilutErev: ITatPeilut[];
  tatPeilutKlali: ITatPeilut[];
  showTatPeilut: boolean = false;
  is_tat_peilut_zugy: boolean = false;
  is_zugy_selected: boolean = true;
  shem_ben_zug: string;
  ms_zehut_ben_zug_valid: boolean = true;
  ben_zug_zakay: boolean = true;
  ben_zug_rashum_lepeilut: boolean = false;
  is_chool: boolean = false;
  tokef_darkon_minYear: number = new Date().getFullYear();
  tokef_darkon_maxYear: number = new Date().getFullYear() + 20;

  d: Date = new Date();

  tokefDarkonDatePickerOptions: IMyOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    dayLabels: AppSettings.dayLabels,
    monthLabels: AppSettings.monthLabels,
    showTodayBtn: false,
    minYear: this.tokef_darkon_minYear,
    maxYear: this.tokef_darkon_maxYear,
    firstDayOfWeek: "su",
    alignSelectorRight: true,
    disableSince: { year: this.tokef_darkon_maxYear, month: 1, day: 1 },
    disableUntil: {
      year: this.tokef_darkon_minYear,
      month: this.d.getMonth() + 1,
      day: this.d.getDate(),
    },
  };

  prefixes: Array<Object> = [
    { num: "050", name: "050" },
    { num: "052", name: "052" },
    { num: "053", name: "053" },
    { num: "054", name: "054" },
    { num: "055", name: "055" },
    { num: "058", name: "058" },
  ];
  isvalidform: boolean = true;
  err_desc: string;
  is_submited: boolean = false;


  

  constructor(
    private _peilutService: PeilutService,
    public router: Router,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    //if user will move back on browzer he should reload the captcha.
    // localStorage.setItem("should_load_captcha", "true");

    this._peilutService.getUserDetails().subscribe((peilutData: IUserPeilutData) => {
        this.user = peilutData.user;
        this.peiluyot = peilutData.peiluyotList;
      },
      (error) => {
        if (error.status === 401) {
          localStorage.removeItem("token");
          location.reload();
        } else if (error.status === 400) {
          this.router.navigateByUrl("/peiluyots/rishum-expired");
        } else {
          this.isvalidform = false;
          this.errorMessage = error;
        }
      }
    );

    //this.GetPeiluyot();

    // this._peilutService.getPeiluyot()
    //     .subscribe(peiluyot => {
    //         this.peiluyot = peiluyot;
    //     },
    //     error => {
    //         if (error.includes("401")) {
    //             localStorage.removeItem("token");
    //             location.reload();
    //         } else if (error.includes("400")) {
    //             this.router.navigateByUrl('/peiluyots/rishum-expired');
    //         }
    //         else {
    //             this.isvalidform = false;
    //             this.errorMessage = error;
    //         }
    //     });

    this.rishum = this.fb.group({
      phone: ["", [Validators.required, Validators.pattern("^[1-9][0-9]{6}$")]],
      prefixNum: ["", [Validators.required]],
      k_sug_peilut: ["", [Validators.required]],
      k_tat_sug_peilut: ["", [Validators.required]],
      ishur_horada: ["", [Validators.required]],
      ishur_hishtatfut: ["", Validators.required],
      ms_zehut_ben_zug: [""],
      ms_darkon: [""],
      tr_tokef_darkon: [""],
      shem_prati_loazi: [""],
      shem_mishpacha_loazi: [""],
      ms_darkon_ben_zug: [""],
      tr_tokef_darkon_ben_zug: [""],
      shem_prati_loazi_ben_zug: [""],
      shem_mishpacha_loazi_ben_zug: [""],
      isTransfer: [false]
    });

    window.scrollTo(0, 0);
  }

  getTatPeilutBoker(tatPeilut: ITatPeilut[]): ITatPeilut[]
  {
    const filteredTatPeilut: ITatPeilut[] = tatPeilut.filter(p => p.teur_tr_peilut.includes("בוקר"));
    return filteredTatPeilut.some(p => p !== null) ? filteredTatPeilut : null;
  }

  getTatPeilutErev(tatPeilut: ITatPeilut[]): ITatPeilut[]
  {
    const filteredTatPeilut: ITatPeilut[] = tatPeilut.filter(p => p.teur_tr_peilut.includes("ערב"));
    return filteredTatPeilut.some(p => p !== null) ? filteredTatPeilut : null;
  }

  getTatPeilutNotBokerErev(tatPeilut: ITatPeilut[]): ITatPeilut[]
  {
    const filteredTatPeilut: ITatPeilut[] = tatPeilut.filter(p => !p.teur_tr_peilut.includes("בוקר") && !p.teur_tr_peilut.includes("ערב"));
    return filteredTatPeilut.some(p => p !== null) ? filteredTatPeilut : null;
  }



  GetPeiluyot() {
    this._peilutService.getPeiluyot().subscribe((peiluyot: IPeiluyot[]) => {
        this.peiluyot = peiluyot;
        this.tatpeilut = this.peiluyot[this.user.k_sug_peilut].tat_Peilut;
        this.tatPeilutBoker = this.getTatPeilutBoker(this.tatpeilut);
        this.tatPeilutErev = this.getTatPeilutErev(this.tatpeilut);
        this.tatPeilutKlali = this.getTatPeilutNotBokerErev(this.tatpeilut);
      },
      (error) => {
        this.router.navigateByUrl("/login");
        this.errorMessage = <any>error;
      }
    );
  }

  onSelectionPeilutChange(p: IPeiluyot) 
  {
    this.selectedPeilut = p.peilut;
    this.rishum.patchValue({ isTransfer: false });
    this.tatpeilut = p.tat_Peilut;
    this.tatPeilutBoker = this.getTatPeilutBoker(this.tatpeilut);
    this.tatPeilutErev = this.getTatPeilutErev(this.tatpeilut);
    this.tatPeilutKlali = this.getTatPeilutNotBokerErev(this.tatpeilut);
    this.showTatPeilut = true;
    this.isvalidform = true;

    this.rishum.get("k_tat_sug_peilut").setValue(null);
    this.is_tat_peilut_zugy = false;
    this.is_chool = false;

    this.rishum.patchValue({ ms_zehut_ben_zug: "" });
    this.rishum.patchValue({ ms_darkon_ben_zug: "" });
    this.rishum.patchValue({ tr_tokef_darkon_ben_zug: "" });
    this.rishum.patchValue({ shem_prati_loazi_ben_zug: "" });
    this.rishum.patchValue({ shem_mishpacha_loazi_ben_zug: "" });
  }

  onSelectionSingelChange(value) {
    if (value === "zugy") {
      this.is_zugy_selected = true;
    }
    if (value === "singel") {
      this.is_zugy_selected = false;
      this.ms_zehut_ben_zug_valid = true;
      this.ben_zug_zakay = true;
      this.ben_zug_rashum_lepeilut = false;
      this.rishum.patchValue({ ms_zehut_ben_zug: "" });
      this.rishum.patchValue({ ms_darkon_ben_zug: "" });
      this.rishum.patchValue({ tr_tokef_darkon_ben_zug: "" });
      this.rishum.patchValue({ shem_prati_loazi_ben_zug: "" });
      this.rishum.patchValue({ shem_mishpacha_loazi_ben_zug: "" });
    }
  }

  onSelectionTatPeilutChange(k_tat_sug_peilut: number) 
  {
    this.isvalidform = true;
    this.is_tat_peilut_zugy = this.tatpeilut.filter((t) => t.k_tat_sug_peilut == k_tat_sug_peilut)[0].max_in_room > 1;
    this.is_chool = this.tatpeilut.filter((t) => t.k_tat_sug_peilut == k_tat_sug_peilut)[0].is_chool > 0;
  }

  onMsZehutBenZugChange(ms_zehut) 
  {
    let valid_zehut = this.validatemsZehut(ms_zehut);
    if (valid_zehut) 
    {
      this.ms_zehut_ben_zug_valid = true;
    } 
    else 
    {
      this.ms_zehut_ben_zug_valid = false;
      return;
    }

    this._peilutService.getBenZugDetails(ms_zehut).subscribe((u: IUserDetails) => {
      if (u.full_name != null) 
      {
        if (u.k_sug_peilut > 0) 
        {
          this.ben_zug_rashum_lepeilut = true;
          this.ben_zug_zakay = true;
        } 
        else 
        {
          this.shem_ben_zug = u.full_name;
          this.ben_zug_zakay = true;
          this.ben_zug_rashum_lepeilut = false;
        }
      } 
      else 
      {
        //reset
        this.ben_zug_rashum_lepeilut = false;
        this.ben_zug_zakay = false;
      }
    });
  }

  // radioState(peilut): boolean {
  //     console.log((!this.user.rishum_kodem == peilut))
  //     return (this.user.rishum_kodem == peilut);
  // }

  // radioTatPeilutState(tatPeilut) {
  //     if (tatPeilut.max_le_rishum <= tatPeilut.total_rishum && tatPeilut.max_hamtana <= tatPeilut.total_hamtana) {
  //         return true;
  //     }//tatPeilut.max_le_rishum <= tatPeilut.total_rishum && tatPeilut.max_hamtana <= tatPeilut.total_hamtana;//tatPeilut.max_hamtana >= tatPeilut.total_hamtana;
  //     else { return false; }
  // }

  onSubmit(event, { value, valid }: { value: IRishum; valid: boolean }) {
    event.preventDefault();
    this.is_submited = true;

    if (this.rishum.value.tr_tokef_darkon) 
    {
      value.tr_tokef_darkon = this.setParseDate(this.rishum.value.tr_tokef_darkon);
    }

    if (this.rishum.value.tr_tokef_darkon_ben_zug) 
    {
      value.tr_tokef_darkon_ben_zug = this.setParseDate(this.rishum.value.tr_tokef_darkon_ben_zug);
    }

    this._peilutService.saveRishum(value).subscribe((r: IRishum) => {
        if (r.status) 
        {
          this.router.navigate(["peiluyots/endrishum"]);
        } 
        else 
        {
          this.isvalidform = false;
          this.is_submited = false;
          this.err_desc = r.returnMessage;
          this.GetPeiluyot(); //refresh peiluyot list
        }
      },
      (error) => {
        console.log(error);
        if (error.includes("401")) {
          localStorage.removeItem("token");
          location.reload();
        }
        this.isvalidform = false;
        this.err_desc = "הודעת שגיאה: חלה שגיאה אנא נסו שנית במועד מאוחר יותר";
        this.is_submited = false;
      }
    );
  }

  validatemsZehut(value) {
    if (value.length == 0) return false;

    var result = true;
    var first8 = null;
    var cifratBikoret = null;
    try {
      if (value.length == 10) first8 = value.substring(0, 9);
      else {
        if (value.length == 9) first8 = "0" + value.substring(0, 8);
        else first8 = "00" + value.substring(0, 8);
      }
      cifratBikoret = value.substring(value.length - 1);
      var checkDigits = 0 * 1;
      var temp = 0;
      var i = 0;

      for (i = 1; i <= 9; i++) {
        temp = first8.charAt(i - 1);
        checkDigits = temp * 1 + checkDigits * 1;
        if (i % 2 == 1) {
          checkDigits = temp * 1 + checkDigits * 1;
          if (temp > 4) checkDigits = checkDigits * 1 - 9;
        }
      }
      checkDigits = (10 - (checkDigits % 10)) % 10;
      result = checkDigits * 1 == cifratBikoret * 1;
    } catch (e) {
      result = false;
    }
    if (value == "0") result = false;
    return result;
  }

  setParseDate(m): Date {
    if (m) {
      return new Date(Date.UTC(m.date.year, m.date.month - 1, m.date.day));
    }

    return null;
  }

  isFormInValid() {
    if (
      this.rishum.invalid ||
      this.is_submited ||
      !this.ms_zehut_ben_zug_valid ||
      !this.ben_zug_zakay ||
      this.ben_zug_rashum_lepeilut ||
      (this.is_tat_peilut_zugy &&
        this.is_zugy_selected &&
        this.rishum.get("ms_zehut_ben_zug").value == "")
    ) {
      return true;
    }
    if (this.is_chool) {
      if (
        this.rishum.value.ms_darkon == "" ||
        this.rishum.value.tr_tokef_darkon == "" ||
        this.rishum.value.shem_prati_loazi == "" ||
        this.rishum.value.shem_mishpacha_loazi == ""
      ) {
        return true;
      }
      if (this.is_zugy_selected) {
        if (
          this.rishum.value.ms_darkon_ben_zug == "" ||
          this.rishum.value.tr_tokef_darkon_ben_zug == "" ||
          this.rishum.value.shem_prati_loazi_ben_zug == "" ||
          this.rishum.value.shem_mishpacha_loazi_ben_zug == ""
        ) {
          return true;
        }
      }
    }

    return false;
  }
}
